import { Component, Input, OnInit } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";
import { IUserActions } from "../../../data-types/user-actions.interface";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";

import { LocalStorageService } from "../../../services/local-storage.service";

@Component({
  selector: "sidebar-home",
  templateUrl: "./sidebar-home.component.html",
  styleUrls: ["./sidebar-home.component.scss"],
})
export class SidebarHomeComponent implements OnInit {
  @Input('userType') userType: string;
  @Input("id") id = "";
  userActions: Array<IUserActions> = [];
  actions: Array<IUserActions> = [
    {
      route: "/bookings",
      type: "coworking",
      active: false,
      icon: (prop) => this.getCalendarIcon(prop),
    },
    {
      route: "/spaces",
      type: "coworking",
      active: false,
      icon: (prop) => this.getSpacesIcon(prop),
    },
    {
      route: "/employees",
      type: "company",
      active: false,
      icon: (prop) => this.getUsersIcon(prop),
    },
    {
      route: "/spendings",
      type: "company",
      active: false,
      icon: (prop) => this.getCreditCardIcon(prop),
    },
    {
      route: "/employees",
      type: "company-plus",
      active: false,
      icon: (prop) => this.getUsersIcon(prop),
    },
    {
      route: "/spendings",
      type: "company-plus",
      active: false,
      icon: (prop) => this.getCreditCardIcon(prop),
    },
    {
      route: "/booking",
      type: "company-plus",
      active: false,
      icon: (prop) => this.getCalendarIcon(prop),
    },
    {
      route: "/spaces",
      type: "company-plus",
      active: false,
      icon: (prop) => this.getSpacesIcon(prop),
    },
  ];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {
    router.events.subscribe((val) => {
      // // see also

      if (val instanceof NavigationEnd) {
        if (this.userType) {
          this.constructPath();
        }
      }
    });
  }
  ngOnInit() {
    if (this.userType) {
      this.constructPath();
    }
  }

  logOut() {
    this.localStorageService.clear();
    return this.redirectToPath("login");
  }

  constructPath() {
    this.userActions = this.actions
      .filter((action) => {
        return action.type === this.userType;
      })
      .map((action: any) => {
        if (this.router.url === `${this.basePath()}${action.route}`) {
          action.active = true;
          action.actionUrl = action.icon(true);
        } else {
          action.actionUrl = action.icon(false);
        }
        return action;
      });
  }

  basePath(): string {
    let base;
    if (this.userType === 'coworking') {
      base = '/coworking-home';
    } else {
      base = '/company-home';
    }
    return base;
  }

  redirectToPath(path: string) {
    this.router.navigate([`${this.basePath()}${path}`]);
  }

  public getMonitorIcon(active) {
    return active
      ? `${iconsLibrary.monitorActiveSvg}`
      : `${iconsLibrary.monitorSvg}`;
  }

  public getUsersIcon(active) {
    return active
      ? `${iconsLibrary.usersActiveSvg}`
      : `${iconsLibrary.usersSvg}`;
  }

  public getCreditCardIcon(active) {
    return active
      ? `${iconsLibrary.creditcardActiveSvg}`
      : `${iconsLibrary.creditcardSvg}`;
  }

  public getCalendarIcon(active) {
    return active
      ? `${iconsLibrary.calendarActiveSvg}`
      : `${iconsLibrary.calendarSvg}`;
  }

  public getSpacesIcon(active) {
    return active ? `${iconsLibrary.boxActiveSvg}` : `${iconsLibrary.boxSvg}`;
  }

  public get getCowingLogoMenuIcon() {
    return `${iconsLibrary.cowingLogoMenuSvg}`;
  }

  public get getLogoutIcon() {
    return `${iconsLibrary.logoutSvg}`;
  }
}
